/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class ImageAssetsApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Upload an image asset
     * @param body 
     */
    public upload(body?: models.ApiPostContentImages, __unused?: any): Observable<models.ApiImageAsset> {
        const path = '/content/images';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<models.ApiImageAsset>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
                body,
            );
    }

    /**
     * Get the list of image assets
     * @param page 
     */
    public all(page?: number, __unused?: any): Observable<PagedArray<models.ApiImageAsset>> {
        const path = '/content/images';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 
        if (page !== undefined) {
            queryParameters['page'] = <any>page;
        }


        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<PagedArray<models.ApiImageAsset>>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
